var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex items-center space-x-5" }, [
    _c(
      "button",
      {
        staticClass: "link flex items-center space-x-2",
        on: {
          click: function ($event) {
            return _vm.$emit("prev")
          },
        },
      },
      [
        _c(
          "svg",
          {
            staticClass: "w-3 h-3 fill-current",
            attrs: { viewBox: "0 0 6.3 11.1" },
          },
          [
            _c("path", {
              attrs: { d: "M5.6 0l.7.7-4.9 4.9 4.9 4.8-.7.7L0 5.6z" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Prev")]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "h-5 w-px bg-theme" }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "link flex items-center space-x-2",
        on: {
          click: function ($event) {
            return _vm.$emit("next")
          },
        },
      },
      [
        _c("span", [_vm._v("Next")]),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "w-3 h-3 fill-current",
            attrs: { viewBox: "0 0 6.3 11.1" },
          },
          [
            _c("path", {
              attrs: { d: "M.7 11.1l-.7-.7 4.9-4.8L0 .7.7 0l5.6 5.6z" },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }